// PATH: src/config/config.ts
// Aligné sur tc_tilmicode_ui : runtimeConfig (public/config.js — committé pour le
// dev local, régénéré par entrypoint.sh au déploiement) prioritaire, puis
// variables REACT_APP_*. Le dev local appelle l'API UAT AVEC les préfixes ;
// seuls MODE:"dev" (runtimeConfig) vide les préfixes (backends locaux directs).

export type ApiService = "identity" | "tilmischool" | "embed";

type RuntimeConfig = Partial<{
  API_URL: string;
  API_BASE_URL: string; // on supporte les deux clés
  APP_VERSION: string;
  API_TIMEOUT: string | number;
  MODE: string;
  IDENTITY_PREFIX: string;
  TILMISCHOOL_PREFIX: string;
  EMBED_PREFIX: string;
}>;

const rc: RuntimeConfig =
  (typeof window !== "undefined" && window.runtimeConfig) || {};

const env = (process.env as Record<string, string | undefined>) || {};

const pickStr = (...values: Array<string | undefined | null>): string => {
  for (const v of values) {
    if (typeof v === "string" && v.trim() !== "") {
      return v.trim();
    }
  }
  return "";
};

const trimTrailingSlashes = (url: string) => url.replace(/\/+$/, "");

// ---------- Base host (commun à tous les services) ----------
export const apiBaseUrl: string = trimTrailingSlashes(
  pickStr(
    rc.API_URL,
    rc.API_BASE_URL,
    env.REACT_APP_API_BASE_URL // ex: http://localhost:8080 ou https://api.tilmicode.com
  )
);

// ---------- Préfixes par service (ignorés uniquement si MODE:"dev") ----------
const isDev = rc.MODE === "dev";

const IDENTITY_PREFIX = pickStr(
  rc.IDENTITY_PREFIX,
  env.REACT_APP_IDENTITY_PREFIX,
  "/tc_identity"
);
const TILMISCHOOL_PREFIX = pickStr(
  rc.TILMISCHOOL_PREFIX,
  env.REACT_APP_TILMISCHOOL_PREFIX,
  "/tc_tilmischoolbe"
);

// Catalogue du programme marocain (tc_embed_be) : même service et même chemin
// que tc_chat_ui (/tc_embedbe/v1), lu directement par le navigateur avec le
// cookie tc_session.
const EMBED_PREFIX = pickStr(
  rc.EMBED_PREFIX,
  env.REACT_APP_EMBED_PREFIX,
  "/tc_embedbe"
);

const SERVICE_PREFIX: Record<ApiService, string> = {
  identity: isDev ? "" : IDENTITY_PREFIX,
  tilmischool: isDev ? "" : TILMISCHOOL_PREFIX,
  embed: isDev ? "" : EMBED_PREFIX,
};

// ---------- Constructeur d'URL par service ----------
export const buildBaseUrl = (service: ApiService): string => {
  const base = apiBaseUrl || "http://localhost:8080";
  const prefix = SERVICE_PREFIX[service] || "";
  return `${trimTrailingSlashes(base)}${prefix}`;
};

// ---------- Timeout API ----------
const rawTimeout = pickStr(
  typeof rc.API_TIMEOUT === "number" ? String(rc.API_TIMEOUT) : rc.API_TIMEOUT,
  env.REACT_APP_API_TIMEOUT
);
export const apiTimeout: number = rawTimeout ? Number(rawTimeout) : 30000;

export const appVersion: string = pickStr(
  rc.APP_VERSION,
  env.REACT_APP_VERSION,
  "dev"
);

// ---------- Alerte utile en dev ----------
if (!apiBaseUrl) {
  // eslint-disable-next-line no-console
  console.warn("[config] apiBaseUrl est vide. Vérifie public/config.js et .env");
}
